export const COMPANY_MUTATION = {
  COMPANY_LIST: "COMPANY_LIST_COMPANY_MUTATION",
};
